import { booleanPointInPolygon, point } from '@turf/turf';

/* Helper: Check if point is in MultiPolygon or Polygon Feature (respeta los huecos) */
export function isPointInFeature(lat, lng, feature) {
    const type = feature && feature.geometry && feature.geometry.type;
    if (type !== 'Polygon' && type !== 'MultiPolygon') return false;
    return booleanPointInPolygon(point([lng, lat]), feature);
}
